<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'SHIFT_LIST' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button (click)="add()" mat-raised-button>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="startDate"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.id!=null?shift.id:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- Plate Column -->
                    <ng-container matColumnDef="plate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CAR'|translate}} {{'PLATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.car.plate!=null?shift.car.plate:'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Plate Column -->
                    <ng-container matColumnDef="startDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.startDate!=null?(shift.startDate | date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="endDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.endDate!=null?(shift.endDate |date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATUS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.status?("ACTIVE"|translate):("PASSIVE"|translate)}}
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="complated">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPLATION_STATUS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            {{shift.complated?("COMPLATED"|translate):("NOT_COMPLATED"|translate)}}
                        </mat-cell>
                    </ng-container>
                    <!-- setting Column -->
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let shift">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="update(shift)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="containerDetail(shift)">
                                    <mat-icon>info</mat-icon>
                                    <span>{{'CONTAINERS'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteShift(shift)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let shift; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>